import React from "react";
import {
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, LinearProgress
} from "@mui/material";

export default function ReclamosTable({ rows, columns, loading, onRowClick }) {
  return (
    <TableContainer component={Paper}>
      {loading && <LinearProgress />}
      <Table size="small">
        <TableHead>
          <TableRow>
            {columns.map(c => <TableCell key={c.id}>{c.label}</TableCell>)}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(r => (
            <TableRow key={r.id} hover sx={{ cursor: "pointer" }} onClick={() => onRowClick?.(r)}>
              {columns.map(c => (
                <TableCell key={c.id}>
                  {c.render ? c.render(r[c.id], r) : (r[c.id] ?? "-")}
                </TableCell>
              ))}
            </TableRow>
          ))}
          {!rows.length && !loading && (
            <TableRow><TableCell colSpan={columns.length}>Sin resultados</TableCell></TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
